module.exports = __webpack_public_path__ + "static/media/check.89bfb9fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Editor/images/check.svg
// module id = 367
// module chunks = 0